/**
 * This is here for backwards compatibility with 4.2
 * @internal
 */
export { VertexBuffer, Buffer } from "../Buffers/buffer.js";
//# sourceMappingURL=buffer.js.map